import { Typography } from '@mui/material';

const DataRoomSetup: React.FC = () => {
  return (
    <Typography variant="body1" color="grey.500">
      Coming soon.
    </Typography>
  );
};

export default DataRoomSetup;
